import { Text } from '@mantine/core'
import { useForm, zodResolver } from '@mantine/form'
import { ContextModalProps } from '@mantine/modals'
import Form from 'common/Form'
import PlaceInput from 'common/inputs/PlaceInput'
import { useMoveVariant } from 'hooks/variants'
import { Category, Place, Unit, VariantBase } from 'types/products'
import { placeSchema } from 'types/schemas'
import { z } from 'zod'

type Props = {
  variant: VariantBase
}

type FormValues = {
  place: Place
}

export default function MovePlaceModal({ context, id, innerProps: { variant } }: ContextModalProps<Props>) {
  const move = useMoveVariant()
  const form = useForm<FormValues>({
    initialValues: {
      place: {
        rack: variant.place.rack,
        column: variant.place.column,
        shelf: variant.place.shelf,
      },
    },
    validate: zodResolver(z.object({ place: placeSchema })),
  })

  async function submit(values: FormValues) {
    await move.mutateAsync({ variantId: variant.id, place: values.place })
  }

  return (
    <>
      <Text size="sm">
        Przenieś produkt o {variant.category === Category.FABRIC ? 'wysokości' : 'wymiarze'} <b>{variant.size}</b>{' '}
        {variant.category === Category.FABRIC ? 'cm' : ''} i ilości <b>{variant.stock}</b>{' '}
        {variant.unit === Unit.PIECE ? 'sztuk' : variant.unit === Unit.METER ? 'metrów' : 'centymetrów'}. Aktualna półka
        to{' '}
        <b>
          {variant.place.rack}-{variant.place.column}-{variant.place.shelf}
        </b>
        . Podaj nową półkę:
      </Text>
      <Form onSubmit={submit} form={form} onCancel={() => context.closeModal(id)} submitText="Przenieś">
        <PlaceInput form={form} />
      </Form>
    </>
  )
}
